import { Article as ArticleIcon } from '@bnnvara/icons/src/components/UserInterfaceIcons/Article';
import { Audio as AudioIcon } from '@bnnvara/icons/src/components/UserInterfaceIcons/Audio';
import { Play as VideoIcon } from '@bnnvara/icons/src/components/UserInterfaceIcons/Play';
import React from 'react';

const getIcon = (action) => {
  switch (action) {
    case 'articleCreated':
      return <ArticleIcon viewBox="0 0 25 25" height="14" />;
    case 'audioCreated':
      return <AudioIcon />;
    case 'videoCreated':
      return <VideoIcon viewBox="0 0 12 14" height="10" />;
    case 'subscribedToBrand':
      return null;
    default:
      return null;
  }
};

export { getIcon };
